/* global axios */

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const baseUrl = () =>
  `/api/v1/accounts/${accountId()}/aceleres/conversation_transfer_requests`;

let requestSequence = 0;
const freshParams = (params = {}) => {
  requestSequence += 1;
  return {
    params: {
      ...params,
      cache_bust: `${Date.now()}-${requestSequence}`,
    },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  };
};

export default {
  pending() {
    return axios.get(baseUrl(), freshParams());
  },
  status(conversationId) {
    return axios.get(
      `${baseUrl()}/status`,
      freshParams({ conversation_id: conversationId })
    );
  },
  create({ conversationId, targetAssigneeId, justification }) {
    return axios.post(baseUrl(), {
      conversation_id: conversationId,
      target_assignee_id: targetAssigneeId,
      justification,
    });
  },
  managerUpdate({ conversationId, targetAssigneeId }) {
    return axios.post(`${baseUrl()}/manager_update`, {
      conversation_id: conversationId,
      target_assignee_id: targetAssigneeId,
    });
  },
  approve(id) {
    return axios.post(`${baseUrl()}/${id}/approve`);
  },
  reject(id, reason = null) {
    return axios.post(`${baseUrl()}/${id}/reject`, { reason });
  },
};
